import { render } from "./ScheduleGroups.vue?vue&type=template&id=398a7aba"
import script from "./ScheduleGroups.vue?vue&type=script&lang=js"
export * from "./ScheduleGroups.vue?vue&type=script&lang=js"
script.render = render

export default script